<template>
  <div id="kanbancenterwrap">
    <div @click="exit" class="bbtn" style="left: 210px">
      <div style="transform: skewX(40deg)" class="bbtnbtn"></div>
      <a>进入系统</a>
    </div>
    <div id="kanbancenter" style="background:url(static/kanbantop.png);background-size: 100% 100%;">
      <h1>{{ $store.state.csr.name }}</h1>
      <ul>
        <li>当前项目</li>
        <li class="active" @click="open">
          {{ groupItem.name }}<Icon type="ios-arrow-down" />
        </li>
      </ul>
    </div>
    <div @click="kanbanScreen" class="bbtn" style="right: 210px">
      <div style="transform: skewX(-40deg)" class="bbtnbtn"></div>
      <a>{{ $store.state.isFullScreen ? "退出全屏" : "进入全屏" }}</a>
    </div>
    <div @click="goto" class="bbtn" style="right: 10px">
      <div style="transform: skewX(-40deg)" class="bbtnbtn"></div>
      <a>作业看板</a>
    </div>
    <Drawer
      placement="right"
      :closable="false"
      v-model="openGroup"
      draggable
      class="my-drawer"
    >
      <groupTree
        @group="reGroup"
        :filterGroup="false"
        :sousuo="true"
      ></groupTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openGroup: false,
      groupItem: {
        id: 1,
        name: "横琴二桥",
      },
      now: "",
    };
  },
  methods: {
    open() {
      this.openGroup = true;
    },
    exit() {
      this.$router.push({
        path: "/daibanchuli",
      });
    },
    kanbanScreen() {
      document.getElementById("fullScree").click();
    },
    reGroup(v) {
      this.groupItem = v;
      this.$emit("groups", [v]);
      this.openGroup = false;
    },
    goto() {
      this.$router.push({
        path: "/abc",
      });
    },
  },
  mounted() {
    setInterval(() => {
      this.now = this.utils.time(Date.now());
    }, 1000);
  },
};
</script>
<style>
#kanbancenterwrap {
  width: 100%;
  display: flex;
  position: relative;
}
#kanbancenterwrap .bbtn {
  width: 180px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  text-align: center;
  top: 4px;
}

#kanbancenterwrap .bbtnbtn {
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin-right: 10px;
  left: 140px;
  border: solid 2px #4884f4;
  box-shadow: 4px 4px 10px #2585cf inset;
}
#kanbancenterwrap .bbtn:hover .bbtnbtn {
  border: solid 2px #84afff;
  box-shadow: 4px 4px 10px #4fb2fe inset;
}
#kanbancenterwrap .bbtn a {
  font-size: 16px;
  top: 0;
  position: absolute;
  width: 150px;
  left: 0;
  color: aqua;
  display: block;
  width: 100%;
  height: 100%;
}
#kanbancenter {
  width: 1100px;
  height: 70px;
  text-align: center;
  position: relative;
  margin: auto;
}

#kanbancenter h1 {
  margin-top: 10px;
  font-size: 28px;
  position: relative;
  z-index: 2;
  color: #93d4ff;
}
#kanbancenter ul {
  width: 360px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
#kanbancenter ul li {
  margin: 0 5px;
  display: inline-block;
  font-size: 14px;
  color: #999;
}
#kanbancenter ul li.active {
  color: #dedede;cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/kanbanselectGroup.vue